import { render, staticRenderFns } from "./vehicleView.vue?vue&type=template&id=31c0d90f&scoped=true&"
import script from "./vehicleView.vue?vue&type=script&lang=js&"
export * from "./vehicleView.vue?vue&type=script&lang=js&"
import style0 from "./vehicleView.vue?vue&type=style&index=0&id=31c0d90f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0d90f",
  null
  
)

component.options.__file = "vehicleView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDataTable,
  VFlex,
  VProgressCircular,
})
